module.exports = __webpack_public_path__ + "static/media/silliman-hall.30841933.jpg";